import { ArrowRight } from "lucide-react";
import { Button } from "@carpybara/ui/shadcn/button";

export type VinCheckLinkVariant = "primary" | "secondary";

/**
 * Single source of truth for "open the VIN history page" CTAs across
 * the app. Both variants route through the shared shadcn ``<Button>``
 * so the prominent orange CTA and the inline pills are the same
 * underlying component — different shadcn variant only.
 */
export const VinCheckLink = ({
  vin,
  variant = "primary",
  label,
  from,
}: {
  vin: string;
  variant?: VinCheckLinkVariant;
  label: string;
  from?: string | null;
}) => {
  const params = new URLSearchParams({ vin, autorun: "1" });
  if (from) params.set("from", from);
  const href = `/vincheck?${params.toString()}`;

  return (
    // `min-w-0 max-w-full` lets the button shrink inside a constrained
    // flex parent (e.g. the Auction-history header row) instead of
    // forcing horizontal overflow, and the `truncate` span ellipsises
    // the label when a long translation (Georgian, etc.) can't fit. The
    // arrow icon keeps its `shrink-0` so only the text is clipped.
    <Button
      href={href}
      variant={variant === "secondary" ? "outline" : "primary"}
      size="sm"
      aria-label={label}
      className="min-w-0 max-w-full"
      iconEnd={<ArrowRight className="h-3.5 w-3.5" aria-hidden />}
      iconEndMotion="forward"
    >
      <span className="min-w-0 truncate">{label}</span>
    </Button>
  );
};
